// Kins · Pop-up de descuento de primera compra (sin librerías).
(function () {
  var dlg = document.getElementById('KinsPopup');
  if (!dlg) return;
  var fondo = document.querySelector('[data-kins-fondo]');
  var CERRADO = 'kins_popup_cerrado';
  var SUSCRITO = 'kins_popup_suscrito';
  var leer = function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } };
  var guardar = function (k) { try { window.localStorage.setItem(k, String(Date.now())); } catch (e) {} };
  var focoPrevio = null;
  var abierto = false;
  var timer = null;

  function abrir() {
    if (abierto || dlg.open) return;
    abierto = true;
    window.clearTimeout(timer);
    var img = dlg.querySelector('img[data-src]');
    if (img) { img.src = img.getAttribute('data-src'); img.removeAttribute('data-src'); }
    focoPrevio = document.activeElement;
    fondo.hidden = false;
    dlg.show();
    window.requestAnimationFrame(function () { fondo.classList.add('is-open'); });
    var primero = dlg.querySelector('input:not([type=hidden]), [data-kins-copiar]');
    if (primero) primero.focus({ preventScroll: true });
    document.addEventListener('keydown', alTeclado);
  }

  function cerrar() {
    if (!dlg.open) return;
    if (dlg.getAttribute('data-estado') !== 'exito') guardar(CERRADO);
    dlg.close();
    fondo.classList.remove('is-open');
    fondo.hidden = true;
    document.removeEventListener('keydown', alTeclado);
    if (focoPrevio && focoPrevio.focus) focoPrevio.focus({ preventScroll: true });
  }

  function alTeclado(e) {
    if (e.key === 'Escape') { e.preventDefault(); cerrar(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(dlg.querySelectorAll('a[href], button:not([disabled]), input:not([type=hidden])'), function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var ini = f[0], fin = f[f.length - 1];
    if (e.shiftKey && document.activeElement === ini) { e.preventDefault(); fin.focus(); }
    else if (!e.shiftKey && document.activeElement === fin) { e.preventDefault(); ini.focus(); }
  }

  dlg.querySelector('[data-kins-cerrar]').addEventListener('click', cerrar);
  fondo.addEventListener('click', cerrar);

  // Botón inactivo hasta aceptar el tratamiento de datos y escribir un correo válido.
  var form = dlg.querySelector('form');
  var acepta = dlg.querySelector('[data-kins-acepta]');
  var enviar = dlg.querySelector('[data-kins-enviar]');
  var correo = dlg.querySelector('input[type=email]');
  var nombre = dlg.querySelector('input[name="contact[first_name]"]');
  function revisar() {
    if (!enviar) return;
    enviar.disabled = !(acepta.checked && correo.validity.valid && correo.value.trim() && nombre.value.trim());
  }
  if (form && enviar) {
    form.addEventListener('input', revisar);
    form.addEventListener('change', revisar);
    form.addEventListener('submit', function (e) { revisar(); if (enviar.disabled) e.preventDefault(); });
  }

  // Copiar el código.
  var copiar = dlg.querySelector('[data-kins-copiar]');
  if (copiar) {
    copiar.addEventListener('click', function () {
      var codigo = dlg.getAttribute('data-codigo');
      var listo = function () { copiar.textContent = 'Copiado'; };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(codigo).then(listo, function () { seleccionar(); });
      } else { seleccionar(); }
      function seleccionar() {
        var el = dlg.querySelector('[data-kins-codigo]');
        var r = document.createRange(); r.selectNodeContents(el);
        var s = window.getSelection(); s.removeAllRanges(); s.addRange(r);
        try { if (document.execCommand('copy')) listo(); } catch (err) {}
      }
    });
  }

  var estado = dlg.getAttribute('data-estado');
  if (estado === 'exito') { guardar(SUSCRITO); abrir(); return; }
  if (estado === 'error') { abrir(); return; }
  if (leer(CERRADO) || leer(SUSCRITO)) return;

  var segundos = parseInt(dlg.getAttribute('data-segundos'), 10) || 15;
  timer = window.setTimeout(abrir, segundos * 1000);

  // Escritorio: cuando el cursor sale por arriba de la ventana.
  if (window.matchMedia('(min-width: 990px) and (pointer: fine)').matches) {
    var alSalir = function (e) {
      if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', alSalir); abrir(); }
    };
    document.addEventListener('mouseout', alSalir);
  }
})();
